import { createSelector } from "@reduxjs/toolkit";
import { RootStateOrAny } from "react-redux";
import { FeatureState } from "./types";

export const featureSelector = createSelector(
    (state: RootStateOrAny) => state.features,
    (state: FeatureState) => state
)